import { CaldotcomAccount, EventType } from 'shared/interfaces/Caldotcom';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const caldotcomEndpoint = '/caldotcom';

export const CaldotcomService = {
  getConnectedAccounts: async (): Promise<CaldotcomAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${caldotcomEndpoint}/accounts`
    });

    return response.data;
  },

  connectAccount: async (caldotcomApiKey: string): Promise<CaldotcomAccount> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${caldotcomEndpoint}/connect-account`,
      data: {
        caldotcomApiKey
      }
    });

    return response.data;
  },

  deleteConnectedAccount: async (caldotcomAccountId: string): Promise<void> => {
    await axiosBaseInstance({
      method: 'delete',
      url: `${caldotcomEndpoint}/accounts/${caldotcomAccountId}`
    });
  },

  getEventTypes: async (caldotcomAccountId: string): Promise<EventType[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${caldotcomEndpoint}/accounts/${caldotcomAccountId}/event-types`
    });

    return response.data;
  }
};
